import { registerArchetype } from './index.js';
import { applyDamage, computeDamage, lowestHpEnemy, livingEnemies, effectiveAtk, effectiveDef } from '../combat.js';
registerArchetype({
    id: 'single_target_nuke',
    apply: ({ state, source, params, rng }) => {
        const multiplier = params.multiplier ?? 1;
        const targetMode = params.target ?? 'lowest_hp';
        const enemies = livingEnemies(state, source.side);
        if (enemies.length === 0)
            return;
        const target = targetMode === 'lowest_hp'
            ? lowestHpEnemy(state, source.side)
            : rng.pick(enemies);
        const sourceRuntime = (source.side === 'A' ? state.sideA : state.sideB)[source.slot];
        const damage = computeDamage(effectiveAtk(sourceRuntime) * multiplier, effectiveDef(target.runtime));
        const isCrit = rng.chance(sourceRuntime.crit);
        applyDamage(state, source, { side: source.side === 'A' ? 'B' : 'A', slot: target.slot }, isCrit ? Math.floor(damage * 1.5) : damage, isCrit, rng);
    }
});
